module.exports = __webpack_public_path__ + "static/img_scan@2x-353ff75d88bbc0e7360f8bb44fcf5a1a.png";